import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { WalletItemGenericID } from "../../../store/common";
import * as httpClient from "../../../util/httpClient";
import { Notification } from "../../common/Notification";
import { useForm } from "react-hook-form";
import { getFlowByName } from "../../../config/FlowName";
import * as NextStepFlowAction from "../../../store/nextStepFlowService/actions";
import { ApplicationState } from "../../../store";
import i18nService from "../../../util/Internationalization/i18n/i18n";
import { PATTERNS } from "../../../util/patterns";
import { useTranslation } from "react-i18next";

const IdCardDialog: React.FunctionComponent<{ requestDataCallback(): void; walletItem: WalletItemGenericID; isNew: boolean; closeDialog(): void }> = (props) => {
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const [isLoading, setisLoading] = useState(false);

    const dispatch = useDispatch();
    const lostWalletFlow = useSelector((state: ApplicationState) => getFlowByName(state, "LOST-WALLET-ASSISTANCE"));
    const completeGetStartedItem = (flowID: any, flowName: string) => dispatch(NextStepFlowAction.actionCreators.completeGetStartedItem(flowID, flowName));
    const [idCard, setIdCard] = useState(props.walletItem);
    const [errorMsg, seterrorMsg] = useState("");
    const [hasError, setHasError] = useState(false);

    const [issueDate, setIssueDate] = useState({
        issueMonth: props.walletItem.issueDate ? props.walletItem.issueDate.trim().split("/")[0] : "",
        issueDay: props.walletItem.issueDate ? props.walletItem.issueDate.trim().split("/")[1] : "",
        issueYear: props.walletItem.issueDate ? props.walletItem.issueDate.trim().split("/")[2] : "",
    });

    const [expirationDate, setExpirationDate] = useState({
        expirationMonth: props.walletItem.expirationDate ? props.walletItem.expirationDate.trim().split("/")[0] : "",
        expirationDay: props.walletItem.expirationDate ? props.walletItem.expirationDate.trim().split("/")[1] : "",
        expirationYear: props.walletItem.expirationDate ? props.walletItem.expirationDate.trim().split("/")[2] : "",
    });

    const months = [
        { name: "Jan", value: "01" },
        { name: "Feb", value: "02" },
        { name: "Mar", value: "03" },
        { name: "Apr", value: "04" },
        { name: "May", value: "05" },
        { name: "Jun", value: "06" },
        { name: "Jul", value: "07" },
        { name: "Aug", value: "08" },
        { name: "Sep", value: "09" },
        { name: "Oct", value: "10" },
        { name: "Nov", value: "11" },
        { name: "Dec", value: "12" },
    ];

    /**Validation with react-hook-form ***/
    const { register, errors, formState, handleSubmit } = useForm({
        mode: "onBlur",
        reValidateMode: "onChange",
    });

    const { isValid, isSubmitting } = formState;

    useEffect(() => {
        if (issueDate) {
            if (
                issueDate.issueDay &&
                issueDate.issueDay.length > 0 &&
                issueDate.issueMonth &&
                issueDate.issueMonth.length > 0 &&
                issueDate.issueYear &&
                issueDate.issueYear.length > 0
            ) {
                setIdCard({ ...idCard, issueDate: issueDate.issueMonth + "/" + issueDate.issueDay + "/" + issueDate.issueYear });
            } else {
                setIdCard({
                    ...idCard,
                    issueDate: undefined,
                });
            }
        }
    }, [issueDate]);

    useEffect(() => {
        if (expirationDate) {
            if (
                expirationDate.expirationDay &&
                expirationDate.expirationDay.length > 0 &&
                expirationDate.expirationMonth &&
                expirationDate.expirationMonth.length > 0 &&
                expirationDate.expirationYear &&
                expirationDate.expirationYear.length > 0
            ) {
                setIdCard({ ...idCard, expirationDate: expirationDate.expirationMonth + "/" + expirationDate.expirationDay + "/" + expirationDate.expirationYear });
            } else {
                setIdCard({
                    ...idCard,
                    expirationDate: undefined,
                });
            }
        }
    }, [expirationDate]);

    function onIssueDateChangeHandler(event: any) {
        setHasError(false);
        const elName = event.currentTarget.name;
        setIssueDate({ ...issueDate, [elName as string]: event.currentTarget.value });
    }

    function onExpirationDateChangeHandler(event: any) {
        setHasError(false);
        const elName = event.currentTarget.name;
        setExpirationDate({ ...expirationDate, [elName as string]: event.currentTarget.value });
    }

    const closeDialog = () => {
        document.body.classList.remove("no_scroll");
        props.closeDialog();
    };

    const refresWalletItem = () => {
        closeDialog();
        props.requestDataCallback();
    };

    function onChangeHandler(event: any) {
        setHasError(false);
        const elName = event.currentTarget.name;
        setIdCard({ ...idCard, [elName as string]: event.currentTarget.value });
    }

    const saveItem = () => {
        const requestBody = {
            "lost-wallet": {
                "lost-wallet-genericcard": idCard,
            },
        };
        setisLoading(true);
        httpClient
            .sendRequest("POST", "api/lostWallet/" + (props.isNew ? "addNewWalletItem" : "updateWalletItem"), requestBody)
            .then((data) => {
                setisLoading(false);
                if (data.isSuccess) {
                    if (lostWalletFlow && lostWalletFlow.flowStepStatus !== "COMPLETED") {
                        completeGetStartedItem(lostWalletFlow.flowStepId, lostWalletFlow.flowName ? lostWalletFlow.flowName : " ");
                    }
                    Notification({
                        type: "success",
                        title: props.isNew
                            ? tLang("identityVault.secureStorage.lostWallterWidget.cardPopup.addToastTitle")
                            : tLang("identityVault.secureStorage.lostWallterWidget.cardPopup.updateToastTitle"),
                        message: props.isNew
                            ? tLang("identityVault.secureStorage.lostWallterWidget.cardPopup.addToastMessage")
                            : tLang("identityVault.secureStorage.lostWallterWidget.cardPopup.updateToastMessage"),
                    });
                    refresWalletItem();
                } else if (data.hasError && data.errors.length > 0) {
                    seterrorMsg(data.errors.join(", "));
                    setHasError(true);
                } else {
                    seterrorMsg(tLang("identityVault.secureStorage.lostWallterWidget.cardPopup.unknownError"));
                    setHasError(true);
                }
            })
            .catch(function (error) {
                setisLoading(false);
                Notification({
                    type: "error",
                    title: tLang("identityVault.secureStorage.lostWallterWidget.cardPopup.errorToastTitle"),
                    message: tLang("identityVault.secureStorage.lostWallterWidget.cardPopup.errorToastMesage"),
                    duration: 0,
                });
                closeDialog();
            });
    };

    const issueDateFields = [
        <div className="col-xs-4 col-no-gutter">
            <div className="form-row row">
                <div className="form-label sr-only col-xs-12 col-no-gutter">
                    <label htmlFor="label-issue-day">Issue Day</label>
                </div>
                <div className="form-input col-xs-12 col-no-gutter padding-right-xs">
                    <select
                        ref={register}
                        name="issueDay"
                        className="inputbox"
                        id="label-issue-day"
                        defaultValue={issueDate.issueDay}
                        onChange={onIssueDateChangeHandler}
                    >
                        <option value="">{tLang("identityVault.secureStorage.lostWallterWidget.cardPopup.dropdownHeaders.dateDay")}</option>
                        {Array(31)
                            .fill(null)
                            .map((value, index) => {
                                return (
                                    <option key={index + 1} value={index < 9 ? "0" + (index + 1) : index + 1}>
                                        {index < 9 ? "0" + (index + 1) : index + 1}
                                    </option>
                                );
                            })}
                    </select>
                </div>
            </div>
        </div>,
        <div className="col-xs-4 col-no-gutter">
            <div className="form-row row">
                <div className="form-label sr-only col-xs-12 col-no-gutter">
                    <label htmlFor="label-issue-month1">Issue Month</label>
                </div>
                <div className="form-input col-xs-12 col-no-gutter padding-right-xs">
                    <select
                        ref={register}
                        name="issueMonth"
                        className="inputbox"
                        id="label-issue-month"
                        defaultValue={issueDate.issueMonth}
                        onChange={onIssueDateChangeHandler}
                    >
                        <option value="">{tLang("identityVault.secureStorage.lostWallterWidget.cardPopup.dropdownHeaders.dateMonth")}</option>
                        {months.map((month) => {
                            return (
                                <option key={month.value} value={month.value}>
                                    {month.name}
                                </option>
                            );
                        })}
                    </select>
                </div>
            </div>
        </div>,
        <div className="col-xs-4 col-no-gutter">
            <div className="form-row row">
                <div className="form-label sr-only col-xs-12 col-no-gutter">
                    <label htmlFor="label-issue-year">Issue Year</label>
                </div>
                <div className="form-input col-xs-12 col-no-gutter  padding-right-xs">
                    <select
                        ref={register}
                        name="issueYear"
                        className="inputbox"
                        id="label-issue-year"
                        aria-labelledby="label-issue-year"
                        defaultValue={issueDate.issueYear}
                        onChange={onIssueDateChangeHandler}
                    >
                        <option value="">{tLang("identityVault.secureStorage.lostWallterWidget.cardPopup.dropdownHeaders.dateYear")}</option>
                        {Array(100)
                            .fill(null)
                            .map((value, index) => {
                                const optionValue = new Date().getFullYear() - index;
                                return (
                                    <option key={optionValue} value={optionValue}>
                                        {optionValue}
                                    </option>
                                );
                            })}
                    </select>
                </div>
            </div>
        </div>,
    ];
    const expiryDateFields = [
        <div className="col-xs-4 col-no-gutter">
            <div className="form-row row">
                <div className="form-label sr-only col-xs-12 col-no-gutter">
                    <label htmlFor="label-expiration-day">Expiration Day</label>
                </div>
                <div className="form-input col-xs-12 col-no-gutter padding-right-xs">
                    <select
                        ref={register}
                        name="expirationDay"
                        className="inputbox"
                        id="label-expiration-day"
                        defaultValue={expirationDate.expirationDay}
                        onChange={onExpirationDateChangeHandler}
                    >
                        <option value="">{tLang("identityVault.secureStorage.lostWallterWidget.cardPopup.dropdownHeaders.dateDay")}</option>
                        {Array(31)
                            .fill(null)
                            .map((value, index) => {
                                return (
                                    <option key={index + 1} value={index < 9 ? "0" + (index + 1) : index + 1}>
                                        {index < 9 ? "0" + (index + 1) : index + 1}
                                    </option>
                                );
                            })}
                    </select>
                </div>
            </div>
        </div>,
        <div className="col-xs-4 col-no-gutter">
            <div className="form-row row">
                <div className="form-label sr-only col-xs-12 col-no-gutter">
                    <label htmlFor="label-expiration-month">Expiration Month</label>
                </div>
                <div className="form-input col-xs-12 col-no-gutter padding-right-xs">
                    <select
                        ref={register}
                        name="expirationMonth"
                        className="inputbox"
                        id="label-expiration-month"
                        aria-labelledby="label-expiration-month"
                        defaultValue={expirationDate.expirationMonth}
                        onChange={onExpirationDateChangeHandler}
                    >
                        <option value="">{tLang("identityVault.secureStorage.lostWallterWidget.cardPopup.dropdownHeaders.dateMonth")}</option>
                        {months.map((month) => {
                            return (
                                <option key={month.value} value={month.value}>
                                    {month.name}
                                </option>
                            );
                        })}
                    </select>
                </div>
            </div>
        </div>,
        <div className="col-xs-4 col-no-gutter">
            <div className="form-row row">
                <div className="form-label sr-only col-xs-12 col-no-gutter">
                    <label htmlFor="label-expiration-year">Expiration Year</label>
                </div>
                <div className="form-input col-xs-12 col-no-gutter">
                    <select
                        ref={register}
                        name="expirationYear"
                        className="inputbox"
                        id="label-expiration-year"
                        aria-labelledby="label-expiration-year"
                        defaultValue={expirationDate.expirationYear}
                        onChange={onExpirationDateChangeHandler}
                    >
                        <option value="">{tLang("identityVault.secureStorage.lostWallterWidget.cardPopup.dropdownHeaders.dateYear")}</option>
                        {Array(10)
                            .fill(null)
                            .map((value, index) => {
                                const optionValue = new Date().getFullYear() + index;
                                return (
                                    <option key={optionValue} value={optionValue}>
                                        {optionValue}
                                    </option>
                                );
                            })}
                    </select>
                </div>
            </div>
        </div>,
    ];

    return (
        <React.Fragment>
            {!isLoading ? (
                <>
                    <div className="dialog-header">
                        <div className="dialog-icon">
                            <em className={props.isNew ? "las la-plus" : "las la-edit"}></em>
                        </div>
                        <h1>
                            {props.isNew
                                ? tLang("identityVault.secureStorage.lostWallterWidget.cardPopup.addLabel")
                                : tLang("identityVault.secureStorage.lostWallterWidget.cardPopup.editLabel")}{" "}
                            {tLang("identityVault.secureStorage.lostWallterWidget.cardPopup.title")}
                        </h1>
                    </div>

                    <form onSubmit={handleSubmit(saveItem)} id="id-card-form-container">
                        <div className="dialog-body">
                            <div className={errors["cardType"] ? "form-row row status-error" : "form-row row"}>
                                <div className="form-row inline row">
                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                        <label htmlFor="edit-card-type">
                                            {tLang("identityVault.secureStorage.lostWallterWidget.cardPopup.label.cardType")}{" "}
                                            <span className="required" title="Mandatory">
                                                *
                                            </span>
                                        </label>
                                    </div>
                                    <div role="alert" className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                        <input
                                            aria-required="true"
                                            type="text"
                                            className="inputbox"
                                            id="edit-card-type"
                                            aria-labelledby="edit-card-type"
                                            name="cardType"
                                            defaultValue={idCard.cardType}
                                            onChange={onChangeHandler}
                                            ref={register({
                                                required: true,
                                                pattern: /^[a-zA-Z0-9\s]+$/,
                                            })}
                                            maxLength={30}
                                        />

                                        {errors.cardType && errors.cardType.type === "pattern" && (
                                            <span className="form-error">
                                                {tLang("identityVault.secureStorage.lostWallterWidget.cardPopup.validationMessage.cardType.pattern")}
                                            </span>
                                        )}

                                        {errors.cardType && errors.cardType.type === "required" && (
                                            <span className="form-error">
                                                {tLang("identityVault.secureStorage.lostWallterWidget.cardPopup.validationMessage.cardType.required")}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className={errors["cardNumber"] ? "form-row row status-error" : "form-row row"}>
                                <div className="form-row inline row">
                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                        <label htmlFor="edit-card-number">
                                            {tLang("identityVault.secureStorage.lostWallterWidget.cardPopup.label.cardNumber")}{" "}
                                            <span className="required" title="Mandatory">
                                                *
                                            </span>
                                        </label>
                                    </div>
                                    <div role="alert" className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                        <input
                                            aria-required="true"
                                            type="text"
                                            className="inputbox"
                                            id="edit-card-number"
                                            aria-labelledby="edit-card-number"
                                            name="cardNumber"
                                            defaultValue={idCard.cardNumber}
                                            onChange={onChangeHandler}
                                            ref={register({
                                                required: true,
                                                pattern: /^[a-zA-Z0-9]+$/,
                                            })}
                                            maxLength={20}
                                        />
                                        {errors.cardNumber && errors.cardNumber.type === "required" && (
                                            <span className="form-error">
                                                {tLang("identityVault.secureStorage.lostWallterWidget.cardPopup.validationMessage.cardNumber.required")}
                                            </span>
                                        )}

                                        {errors.cardNumber && errors.cardNumber.type === "pattern" && (
                                            <span className="form-error">
                                                {tLang("identityVault.secureStorage.lostWallterWidget.cardPopup.validationMessage.cardNumber.pattern")}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className={errors["firstName"] ? "form-row row status-error" : "form-row row"}>
                                <div className="form-row inline row">
                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                        <label htmlFor="edit-first-name">
                                            {tLang("identityVault.secureStorage.lostWallterWidget.cardPopup.label.firstName")}{" "}
                                            <span className="required" title="Mandatory">
                                                *
                                            </span>
                                        </label>
                                    </div>
                                    <div role="alert" className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                        <input
                                            aria-required="true"
                                            type="text"
                                            className="inputbox"
                                            id="edit-first-name"
                                            aria-labelledby="edit-first-name"
                                            name="firstName"
                                            defaultValue={idCard.firstName}
                                            onChange={onChangeHandler}
                                            ref={register({
                                                required: true,
                                                pattern: PATTERNS.FIRSTNAME.pattern,
                                            })}
                                            maxLength={30}
                                        />
                                        {errors.firstName && errors.firstName.type === "pattern" && (
                                            <span className="form-error">
                                                {tLang("identityVault.secureStorage.lostWallterWidget.cardPopup.validationMessage.firstName.pattern")}
                                            </span>
                                        )}

                                        {errors.firstName && errors.firstName.type === "required" && (
                                            <span className="form-error">
                                                {tLang("identityVault.secureStorage.lostWallterWidget.cardPopup.validationMessage.firstName.required")}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className={errors["middleName"] ? "form-row row status-error" : "form-row row"}>
                                <div className="form-row inline row">
                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                        <label htmlFor="edit-middle-initial">
                                            {tLang("identityVault.secureStorage.lostWallterWidget.cardPopup.label.middleInitial")}
                                        </label>
                                    </div>
                                    <div role="alert" className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                        <input
                                            aria-required="true"
                                            type="text"
                                            className="inputbox"
                                            id="edit-middle-initial"
                                            aria-labelledby="edit-middle-initial"
                                            name="middleName"
                                            defaultValue={idCard.middleName}
                                            onChange={onChangeHandler}
                                            ref={register({
                                                pattern: PATTERNS.MIDDLE_INITIAL.pattern,
                                            })}
                                            maxLength={1}
                                        />
                                        {errors.middleName && errors.middleName.type === "pattern" && (
                                            <span className="form-error">
                                                {tLang("identityVault.secureStorage.lostWallterWidget.cardPopup.validationMessage.middleInitial.pattern")}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className={errors["lastName"] ? "form-row row status-error" : "form-row row"}>
                                <div className="form-row inline row">
                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                        <label htmlFor="edit-last-name">
                                            {tLang("identityVault.secureStorage.lostWallterWidget.cardPopup.label.lastName")}{" "}
                                            <span className="required" title="Mandatory">
                                                *
                                            </span>
                                        </label>
                                    </div>
                                    <div role="alert" className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                        <input
                                            aria-required="true"
                                            type="text"
                                            className="inputbox"
                                            id="edit-last-name"
                                            aria-labelledby="edit-last-name"
                                            name="lastName"
                                            defaultValue={idCard.lastName}
                                            onChange={onChangeHandler}
                                            ref={register({
                                                required: true,
                                                pattern: PATTERNS.LASTNAME.pattern,
                                            })}
                                            maxLength={30}
                                        />
                                        {errors.lastName && errors.lastName.type === "pattern" && (
                                            <span className="form-error">
                                                {tLang("identityVault.secureStorage.lostWallterWidget.cardPopup.validationMessage.lastName.pattern")}
                                            </span>
                                        )}

                                        {errors.lastName && errors.lastName.type === "required" && (
                                            <span className="form-error">
                                                {tLang("identityVault.secureStorage.lostWallterWidget.cardPopup.validationMessage.lastName.required")}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="form-row inline row">
                                <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                    <label htmlFor="edit-suffix">{tLang("identityVault.secureStorage.lostWallterWidget.cardPopup.label.suffix")}</label>
                                </div>
                                <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                    <select
                                        className="inputbox"
                                        id="edit-suffix"
                                        aria-labelledby="edit-suffix"
                                        name="suffix"
                                        defaultValue={idCard.suffix}
                                        onChange={onChangeHandler}
                                    >
                                        <option value="">{tLang("identityVault.secureStorage.lostWallterWidget.cardPopup.dropdownHeaders.suffix")}</option>
                                        <option value="Sr">Sr</option>
                                        <option value="Jr">Jr</option>
                                        <option value="II">II</option>
                                        <option value="III">III</option>
                                        <option value="IV">IV</option>
                                    </select>
                                </div>
                            </div>

                            <div className="form-row inline row">
                                <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                    <label htmlFor="edit-description">{tLang("identityVault.secureStorage.lostWallterWidget.cardPopup.label.description")}</label>
                                </div>
                                <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                    <input
                                        type="text"
                                        className="inputbox"
                                        id="edit-description"
                                        aria-labelledby="edit-description"
                                        name="description"
                                        maxLength={500}
                                        defaultValue={idCard.description}
                                        onChange={onChangeHandler}
                                    />
                                </div>
                            </div>

                            <div className="form-row inline row">
                                <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                    <label htmlFor="label-issue-month">{tLang("identityVault.secureStorage.lostWallterWidget.cardPopup.label.issueDate")}</label>
                                </div>
                                <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                    <div className="row ">
                                        {i18nService.get("Country") == "US" ? (
                                            <>
                                                {issueDateFields[1]} {issueDateFields[0]} {issueDateFields[2]}{" "}
                                            </>
                                        ) : i18nService.get("Country") == "CA" || i18nService.get("Country") == "TW" ? (
                                            <>
                                                {issueDateFields[2]} {issueDateFields[1]} {issueDateFields[0]}{" "}
                                            </>
                                        ) : (
                                            <>
                                                {issueDateFields[0]} {issueDateFields[1]} {issueDateFields[2]}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="form-row inline row">
                                <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                    <label htmlFor="label-expiration-month">{tLang("identityVault.secureStorage.lostWallterWidget.cardPopup.label.expiryDate")}</label>
                                </div>
                                <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                    <div className="row ">
                                        {i18nService.get("Country") == "US" ? (
                                            <>
                                                {expiryDateFields[1]} {expiryDateFields[0]} {expiryDateFields[2]}{" "}
                                            </>
                                        ) : i18nService.get("Country") == "CA" || i18nService.get("Country") == "TW" ? (
                                            <>
                                                {expiryDateFields[2]} {expiryDateFields[1]} {expiryDateFields[0]}{" "}
                                            </>
                                        ) : (
                                            <>
                                                {expiryDateFields[0]} {expiryDateFields[1]} {expiryDateFields[2]}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="form-row inline row">
                                <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                    <label htmlFor="edit-notes">{tLang("identityVault.secureStorage.lostWallterWidget.cardPopup.label.notes")}</label>
                                </div>
                                <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                    <textarea
                                        className="inputbox"
                                        id="edit-notes"
                                        aria-labelledby="edit-notes"
                                        name="notes"
                                        maxLength={500}
                                        style={{ resize: "none" }}
                                        placeholder=""
                                        rows={6}
                                        defaultValue={idCard.notes}
                                        onChange={onChangeHandler}
                                    ></textarea>
                                </div>
                            </div>

                            {hasError && (
                                <div className="form-row inline row">
                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter"></div>
                                    <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                        <p className="form-error">{errorMsg}</p>
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className="dialog-footer">
                            <div className="row between-xs">
                                <div className="col-xs col-no-gutter flex-grow-null">
                                    <button type="button" className="btn-default btn-link btn-no-padding btn-no-border" onClick={() => closeDialog()}>
                                        <span className="btn-text">{tLang("identityVault.secureStorage.lostWallterWidget.cardPopup.label.cancelButtonText")}</span>
                                    </button>
                                </div>
                                <div className="col-xs col-no-gutter flex-grow-null">
                                    <button type="submit" className="btn-default btn-primary" disabled={isSubmitting}>
                                        <span className="btn-text">{tLang("identityVault.secureStorage.lostWallterWidget.cardPopup.label.saveButtonText")}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </>
            ) : (
                <div className="box loading"></div>
            )}
        </React.Fragment>
    );
};

export default IdCardDialog;
